const TEST_EMAIL_SUFFIX = "hupo.co";
export const isTestAccount = (email: string): boolean => {
  // If email contains + in the prefix and ends with @hupo.co
  // or if the email contains +test in the prefix with any domain
  // then it is a test account
  const [prefix, suffix] = email.split("@");

  const hupoEmailAndContainsPlus =
    suffix === TEST_EMAIL_SUFFIX && prefix.includes("+");

  const anyDomainEmailAndContainsPlusTest = prefix.includes("+test");

  return hupoEmailAndContainsPlus || anyDomainEmailAndContainsPlusTest;
};
